<template>
  <div class="wrapper">
    <h1>Ustawienia konta</h1>
    <section class="main">
      <h2>Limity</h2>
      <Loader v-if="!settingsLoaded" />
      <div v-else>
        <form id="limits-form">
        <section>
        <h3>Dzienne limity</h3>
          <NumberInput :label="'Dzienny limit akcji (łącznie)'"
            :id="'actionsLimit'" :min="0" :max="600" />
          <NumberInput :label="'Dzienny limit obserwacji'"
            :id="'followsLimit'" :min="0" :max="250" />
          <NumberInput :label="'Dzienny limit polubień'"
            :id="'likesLimit'" :min="0" :max="250" />
          <NumberInput :label="'Dzienny limit odobserwowań'"
            :id="'unfollowsLimit'" :min="0" :max="250" />
        </section>
        <section>
        <h3>Przerwy</h3>
          <NumberInput :label="'Minimalna przerwa między akcjami'"
            :id="'minIntervalMilliseconds'" :min="0" :max="3000" />
          <NumberInput :label="'Maksymalna przerwa między akcjami'"
            :id="'maxIntervalMilliseconds'" :min="3000" :max="10000" />
        </section>
        </form>
        <button @click="updateAccountSettings" class="save-btn">
          Zapisz
        </button>
      </div>
    </section>
    <section class="main danger">
      <h2>Strefa zagrożenia</h2>
      <button @click="showModal('DeleteInstagramAccountModal')" class="btn-red">
        Usuń konto
      </button>
    </section>
  </div>
</template>

<script>
import EventBus from '@/event-bus';
import Loader from '@/components/Loader.vue';
import NumberInput from '@/components/inputs/NumberInput.vue';

export default {
  name: "ProfileDashboard",
  components: {
    Loader,
    NumberInput
  },
  data() {
    return {
      loadingPromotions: false
    };
  },
  computed: {
    settingsLoaded() {
      return this.$store.getters.settingsLoaded;
    }
  },
  created() {
    this.$store.dispatch('getCurrentAccountsSettings');
    EventBus.$on('profileChanged', () => {
      this.$store.dispatch('getCurrentAccountsSettings');
    });
  },
  methods: {
    showModal(modalName) {
      this.$store.commit('showModal', modalName);
    },
    updateAccountSettings() {
      this.$store.dispatch('updateCurrentAccountsSettings');
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 15px 15px;
  width: 100%;
  overflow: auto;
  height: 100vh;
  max-height: 100%;
}

section.main {
  border: 1px solid #707070;
  border-radius: 15px;
  padding: 10px;
  margin-bottom: 30px;

  > h2 {
    position: relative;
    top: -1.75rem;
    left: 10px;
    display: inline-block;
    padding: 0 15px;
    background: #2A2A2A;
    width: max-content;
    text-align: center;

    & + * {
      margin-top: -20px;
    }
  }
}

h1 {
  margin-top: 15px;
  margin-bottom: calc(15px + 1.75rem);
  text-align: center;
}

h2 {
  margin: 0;
}

h3 {
  margin: 15px;
}

.save-btn {
  margin-top: 30px;
}

section.danger {
  border: 1px solid rgb(237, 33, 58);
  border-radius: 15px;
  padding: 15px;

  button {
    text-align: center;

    @media (min-width: 768px) {
      text-align: left;
    }
  }
}

.btn-red {
  @media (min-width: 768px) {
    margin: 10px 0;
  }
}

#limits-form {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
}

</style>
